import { ResourceType } from '@/services/common/enums';
export default {
    [ResourceType.VectorLayer]: { icon: 'fas fa-layer-group', color: 'yellow-300' },
    [ResourceType.RasterLayer]: { icon: 'fas fa-image', color: 'yellow-300' },
    [ResourceType.Table]: { icon: 'fas fa-table-cells', color: 'yellow-300' },
    [ResourceType.ExternalApplication]: { icon: 'fas fa-gauge-high', color: 'yellow-300' },
    [ResourceType.PythonNotebook]: { icon: 'fab fa-python', color: 'yellow-300' },
    [ResourceType.Scenario]: { icon: 'fas fa-note-sticky', color: 'yellow-300' },
};
